
export enum ScoEventStatusCd {
	DELIVERED = 'Delivered',
	FAILED = 'Failed',
	QUEUED = 'Queued',
	REVIEWED = 'Reviewed',
	SUCCESSFUL = 'Successful',
	TEXT_FROM_DEVICE = 'TextFromDevice'}
